import styled from '@emotion/styled';
import * as React from 'react';
import { colors, fontWeight } from '~/styles/constants';

interface LinkProps {
  id?: string;
  href?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  target?: string;
  hideUnderline?: boolean;
  dataE2E?: string;
  dataHeap?: string;
  // This will also set data-testid
  dataAnalytics?: string;
  dataPendo?: string;
  disabled?: boolean; // if true, the Link's color and text-decoration styling will be overridden to the disabled styling
  className?: string;
  rel?: string;
  children?: React.ReactNode;
  tabIndex?: number;
}

const LinkComponent = styled('a')<LinkProps>`
  font-size: inherit;
  cursor: pointer;
  text-decoration: ${(props) => (props.hideUnderline ? 'none' : 'normal')};
  ${(props) =>
    props.disabled
      ? `color: ${colors.gray400} !important;
    cursor: not-allowed;
    text-decoration: none !important;`
      : ''}
`;

const Link = (props: LinkProps) => {
  const {
    children,
    className,
    dataAnalytics,
    dataPendo,
    href,
    target,
    id,
    onClick,
    disabled,
    hideUnderline,
    dataE2E,
    dataHeap,
    rel,
    tabIndex,
  } = props;
  const elementProps = {
    href,
    target,
    id,
    rel,
  };

  return (
    <LinkComponent
      {...elementProps}
      className={className}
      data-pendo={dataPendo}
      data-heap-event={dataAnalytics}
      data-analytics={dataAnalytics}
      data-testid={dataAnalytics}
      data-e2e={dataE2E}
      data-heap={dataHeap}
      onClick={onClick}
      disabled={disabled}
      hideUnderline={hideUnderline}
      tabIndex={tabIndex}
    >
      {children}
    </LinkComponent>
  );
};

export default Link;

export const GreenLink = styled(Link)`
  color: ${colors.primary};
`;

export const BlueLink = styled(Link)`
  color: ${colors.aqua};
`;

export const DeepBlueLink = styled(Link)`
  color: ${colors.forest700};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:active {
    text-decoration: underline;
  }
`;

export const DeepBlueBoldLink = styled(DeepBlueLink)`
  font-size: 0.875rem;
  font-weight: ${fontWeight.medium};
`;

export const GreyLink = styled(Link)`
  color: ${colors.secondary};
`;

export const DarkGrayLink = styled(Link)`
  color: ${colors.gray700};
  &:hover {
    text-decoration: underline;
  }

  &:active {
    text-decoration: underline;
  }
`;

export const LightGrayLink = styled(Link)`
  color: ${colors.gray400};
`;

export const EditLink = styled(GreyLink)`
  font-weight: ${fontWeight.normal};
  text-decoration: underline;
`;

export const LearnMoreLink = styled(Link)`
  color: ${colors.primaryAlternative};
`;

export const SupportEmailLink = styled(Link)`
  color: ${colors.primaryAlternative};
`;

export const DangerLink = styled(Link)`
  color: ${colors.ruby700};
`;
